module.exports = __webpack_public_path__ + "static/media/TW-puzzle-wordSearch-min.b8fa3c96.jpg";